<template>
  <div class="student-list">
    <el-card>
      <div slot="header">
        <span>学生列表</span>
      </div>
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="头像" width="80">
          <template slot-scope="scope">
            <el-avatar :src="scope.row.avatar" size="small"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="current_level" label="当前关卡"></el-table-column>
        <el-table-column prop="total_medals" label="勋章数"></el-table-column>
        <el-table-column prop="created_at" label="注册时间"></el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="size"
        layout="total, prev, pager, next"
        :total="total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      page: 1,
      size: 20,
      total: 0
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.getStudents({ page: this.page, size: this.size });
        this.tableData = res.items;
        this.total = res.total;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.student-list {
  padding: 20px;
}
</style>
